import Notification, {NotificationTypeId} from '../models/entities/notification';
import UserNotificationType from '../models/entities/user-notification-type';

const maintenanceNotificationIds: number[] = [];

const notificationUtils = {
  isWarning: function (notification: Notification) {
    return !maintenanceNotificationIds.includes(notification.notificationTypeId);
  },
  isMaintenance: function (notification: Notification) {
    return maintenanceNotificationIds.includes(notification.notificationTypeId);
  },
  getSettingsLabel: function (userNotificationType: UserNotificationType) {
    switch (userNotificationType.notificationTypeId) {
      case NotificationTypeId.OvenPanelTurnedOn:
        return 'notification_settings_oven_panel_turned_on';
      case NotificationTypeId.OvenPanelTurnedOff:
        return 'notification_settings_oven_panel_turned_off';
      case NotificationTypeId.OvenPanelStartedRecipe:
        return 'notification_settings_oven_panel_started_recipe';
      case NotificationTypeId.OvenPanelFinishedRecipe:
        return 'notification_settings_oven_panel_finished_recipe';
      case NotificationTypeId.OvenPanelStartedWashing:
        return 'notification_settings_oven_panel_started_washing';
      case NotificationTypeId.OvenPanelFinishedWashing:
        return 'notification_settings_oven_panel_finished_washing';
      case NotificationTypeId.OvenPanelStartedSync:
        return 'notification_settings_oven_panel_started_sync';
      case NotificationTypeId.OvenPanelFinishedSync:
        return 'notification_settings_oven_panel_finished_sync';
      case NotificationTypeId.OvenPanelFailedSync:
        return 'notification_settings_oven_panel_failed_sync';
      case NotificationTypeId.OvenPanelStartedUpdate:
        return 'notification_settings_oven_panel_started_app_update';
      case NotificationTypeId.OvenPanelFinishedUpdate:
        return 'notification_settings_oven_panel_finished_app_update';
      case NotificationTypeId.OvenPanelFailedUpdate:
        return 'notification_settings_oven_panel_failed_app_update';
      case NotificationTypeId.OvenPanelStartedOverheat:
        return 'notification_settings_oven_panel_started_overheating';
      case NotificationTypeId.OvenPanelStoppedOverheat:
        return 'notification_settings_oven_panel_stopped_overheating';
      case NotificationTypeId.OvenPanelStartedTurbineOverheat:
        return 'notification_settings_oven_panel_started_turbine_overheating';
      case NotificationTypeId.OvenPanelStoppedTurbineOverheat:
        return 'notification_settings_oven_panel_stopped_turbine_overheating';
      case NotificationTypeId.OvenPanelStartedPowerFailure:
        return 'notification_settings_oven_panel_started_power_failure';
      case NotificationTypeId.OvenPanelStoppedPowerFailure:
        return 'notification_settings_oven_panel_stopped_power_failure';
      case NotificationTypeId.OvenPanelSettingsChanged:
        return 'notification_settings_oven_panel_settings_changed';
      case NotificationTypeId.PeriodicMaintenanceRequired:
        return 'notification_settings_periodic_maintenance_required';
      case NotificationTypeId.StartedPCBOverheating:
        return 'notification_settings_oven_panel_started_pcb_overheating';
      case NotificationTypeId.StoppedPCBOverheating:
        return 'notification_settings_oven_panel_stopped_pcb_overheating';
      case NotificationTypeId.StartedThermocoupleError:
        return 'notification_settings_oven_panel_started_thermocouple_error';
      case NotificationTypeId.StoppedThermocoupleError:
        return 'notification_settings_oven_panel_stopped_thermocouple_error';
      case NotificationTypeId.StartedThermocoupleTemperatureMeasurementError:
        return 'notification_settings_oven_panel_started_thermocouple_temperature_measurement_error';
      case NotificationTypeId.StoppedThermocoupleTemperatureMeasurementError:
        return 'notification_settings_oven_panel_stopped_thermocouple_temperature_measurement_error';
      case NotificationTypeId.StartedThermocoupleConnectionError:
        return 'notification_settings_oven_panel_started_thermocouple_connection_error';
      case NotificationTypeId.StoppedThermocoupleConnectionError:
        return 'notification_settings_oven_panel_stopped_thermocouple_connection_error';
      case NotificationTypeId.StartedThermocoupleTemperatureMeasurementStuckError:
        return 'notification_settings_oven_panel_started_thermocouple_temperature_measurement_stuck_error';
      case NotificationTypeId.StoppedThermocoupleTemperatureMeasurementStuckError:
        return 'notification_settings_oven_panel_stopped_thermocouple_temperature_measurement_stuck_error';
      case NotificationTypeId.StartedForcedCoolingError:
        return 'notification_settings_oven_panel_started_forced_cooling_error';
      case NotificationTypeId.StoppedForcedCoolingError:
        return 'notification_settings_oven_panel_stopped_forced_cooling_error';
      default:
        return '';
    }
  },
  getLabel: function (notification: Notification) {
    switch (notification.notificationTypeId) {
      case NotificationTypeId.OvenPanelTurnedOn:
        return 'notification_oven_panel_turned_on';
      case NotificationTypeId.OvenPanelTurnedOff:
        return 'notification_oven_panel_turned_off';
      case NotificationTypeId.OvenPanelStartedRecipe:
        return 'notification_oven_panel_started_recipe';
      case NotificationTypeId.OvenPanelFinishedRecipe:
        return 'notification_oven_panel_finished_recipe';
      case NotificationTypeId.OvenPanelStartedWashing:
        return 'notification_oven_panel_started_washing';
      case NotificationTypeId.OvenPanelFinishedWashing:
        return 'notification_oven_panel_finished_washing';
      case NotificationTypeId.OvenPanelStartedSync:
        return 'notification_oven_panel_started_sync';
      case NotificationTypeId.OvenPanelFinishedSync:
        return 'notification_oven_panel_finished_sync';
      case NotificationTypeId.OvenPanelFailedSync:
        return 'notification_oven_panel_failed_sync';
      case NotificationTypeId.OvenPanelStartedUpdate:
        return 'notification_oven_panel_started_app_update';
      case NotificationTypeId.OvenPanelFinishedUpdate:
        return 'notification_oven_panel_finished_app_update';
      case NotificationTypeId.OvenPanelFailedUpdate:
        return 'notification_oven_panel_failed_app_update';
      case NotificationTypeId.OvenPanelStartedOverheat:
        return 'notification_oven_panel_started_overheating';
      case NotificationTypeId.OvenPanelStoppedOverheat:
        return 'notification_oven_panel_stopped_overheating';
      case NotificationTypeId.OvenPanelStartedTurbineOverheat:
        return 'notification_oven_panel_started_turbine_overheating';
      case NotificationTypeId.OvenPanelStoppedTurbineOverheat:
        return 'notification_oven_panel_stopped_turbine_overheating';
      case NotificationTypeId.OvenPanelStartedPowerFailure:
        return 'notification_oven_panel_started_power_failure';
      case NotificationTypeId.OvenPanelStoppedPowerFailure:
        return 'notification_oven_panel_stopped_power_failure';
      case NotificationTypeId.OvenPanelSettingsChanged:
        return 'notification_oven_panel_settings_changed';
      case NotificationTypeId.PeriodicMaintenanceRequired:
        return 'notification_periodic_maintenance_required';
      case NotificationTypeId.StartedPCBOverheating:
        return 'notification_oven_panel_started_pcb_overheating';
      case NotificationTypeId.StoppedPCBOverheating:
        return 'notification_oven_panel_stopped_pcb_overheating';
      case NotificationTypeId.StartedThermocoupleError:
        return 'notification_oven_panel_started_thermocouple_error';
      case NotificationTypeId.StoppedThermocoupleError:
        return 'notification_oven_panel_stopped_thermocouple_error';
      case NotificationTypeId.StartedThermocoupleTemperatureMeasurementError:
        return 'notification_oven_panel_started_thermocouple_temperature_measurement_error';
      case NotificationTypeId.StoppedThermocoupleTemperatureMeasurementError:
        return 'notification_oven_panel_stopped_thermocouple_temperature_measurement_error';
      case NotificationTypeId.StartedThermocoupleConnectionError:
        return 'notification_oven_panel_started_thermocouple_connection_error';
      case NotificationTypeId.StoppedThermocoupleConnectionError:
        return 'notification_oven_panel_stopped_thermocouple_connection_error';
      case NotificationTypeId.StartedThermocoupleTemperatureMeasurementStuckError:
        return 'notification_oven_panel_started_thermocouple_temperature_measurement_stuck_error';
      case NotificationTypeId.StoppedThermocoupleTemperatureMeasurementStuckError:
        return 'notification_oven_panel_stopped_thermocouple_temperature_measurement_stuck_error';
      case NotificationTypeId.StartedForcedCoolingError:
        return 'notification_oven_panel_started_forced_cooling_error';
      case NotificationTypeId.StoppedForcedCoolingError:
        return 'notification_oven_panel_stopped_forced_cooling_error';
      default:
        return notification.notificationTypeDescription;
    }
  },
};

export default notificationUtils;
